<smrts-page [tabTitle]="title">

  <div header class="header inline-element">
    <h1 class="primary-color page-title page-title-full">{{title}}</h1>
    <h1 class="primary-color page-title page-title-short">Caixa</h1>

    <div class="inline-element center-header">
      <p-floatlabel variant="on" class="data-field">
        <p-datepicker [showIcon]="true" dateFormat="dd/mm/yy" [(ngModel)]="dataMin" [fluid]="true" />
        <label>Data inicio</label>
      </p-floatlabel>
      <p-floatlabel variant="on" class="data-field">
        <p-datepicker [showIcon]="true" dateFormat="dd/mm/yy" [(ngModel)]="dataMax" [fluid]="true" />
        <label>Data fim</label>
      </p-floatlabel>
      <button class="white-text-button" mat-flat-button (click)="buscarClick()">
        Buscar
      </button>
    </div>

    <button class="white-text-button btn-busca-popover" mat-raised-button matTooltip="Buscar" (click)="popoverBusca.toggle($event)">
      <mat-icon>search</mat-icon>
    </button>

    <p-popover #popoverBusca appendTo="body">
      <div class="popover-busca-content">
        <p-floatlabel variant="on">
          <p-datepicker [showIcon]="true" dateFormat="dd/mm/yy" [(ngModel)]="dataMin" [fluid]="true" />
          <label>Data inicio</label>
        </p-floatlabel>
        <p-floatlabel variant="on">
          <p-datepicker [showIcon]="true" dateFormat="dd/mm/yy" [(ngModel)]="dataMax" [fluid]="true" />
          <label>Data fim</label>
        </p-floatlabel>
        <button class="white-text-button" mat-flat-button (click)="buscarClick(); popoverBusca.hide()">
          Buscar
        </button>
      </div>
    </p-popover>
  </div>

  <div class="content">
    <p-splitter [style]="{ height: '100%' }" [panelSizes]="[62, 38]" class="mb-8">
      <ng-template #panel>
        <div class="lotes-panel">

          <div class="lote-header">
            <h2 class="accent-color">
              @if (diaExibido) {
                Lotes - {{ diaExibido.data | date:'dd/MM/yyyy' }}
              } @else {
                Lotes
              }
            </h2>

            <div class="inline-element right-header">
              <button *hasPermission="permissaoEditarLancamento" pButton pRipple type="button" icon="pi pi-plus" label="Novo"
              text rounded severity="secondary" class="btn-novo-rapido" matTooltip="Adição rápida de lote" (click)="abrirDialogAdicionarLote()"></button>
              <a *hasPermission="permissaoEditarLancamento" routerLink="/lote-lancamentos" [queryParams]="diaExibido ? { data: diaExibido.data } : null"
              pButton pRipple icon="pi pi-file-edit" label="Novo" text rounded severity="secondary" matTooltip="Abrir página de cadastro"></a>
            </div>
          </div>

          <!-- Tabela dos lançamentos do dia -->
          @if (diaExibido !== undefined) {
            <div class="table-container">
              <p-table #tabelaLotes [value]="diaExibido.lotesLancamentos" [scrollable]="true" scrollHeight="flex" sortMode="multiple"
                [expandedRowKeys]="expandedRows" dataKey="id" editMode="row">
                <ng-template pTemplate="header">
                  <tr>
                    <th></th> <!-- espaço para o botão de expandir -->
                    <th pSortableColumn="nome">Nome do Lote<p-sortIcon field="nome" /></th>
                    <th pSortableColumn="quantidade">Numero de lançamentos<p-sortIcon field="quantidade" /></th>
                    <th pSortableColumn="credito">Crédito<p-sortIcon field="credito" /></th>
                    <th pSortableColumn="diferenca">Diferença<p-sortIcon field="diferenca" /></th>
                    <th style="width: 130px;"></th> <!-- Espaço para botões -->
                  </tr>
                </ng-template>
                <!-- Modelo da Tabela primaria -->
                <ng-template #body let-lote let-rowIndex="rowIndex" let-expanded="expanded" let-editing="editing">
                  <tr [pEditableRow]="lote">
                    <td>
                      <p-button type="button" pRipple [pRowToggler]="lote" [text]="true" [rounded]="true" [plain]="true"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
                      </td>
                      <td>
                        <p-cellEditor>
                          <ng-template #input>
                            <input pInputText type="text" [(ngModel)]="lote.nome" />
                          </ng-template>
                          <ng-template #output>
                            {{ lote.nome }}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                      <td>{{ lote.quantidade }}</td>
                      <td class="green-text">{{ lote.credito | currency:'BRL' }}</td>
                      <td [ngClass]="{'orange-warning-diferenca': lote.diferenca !== 0}">{{ lote.diferenca |
                      currency:'BRL' }}</td>
                      <td>
                        @if (!editing) {
                          <div class="inline-element items-center">
                            <button pButton pRipple type="button" pInitEditableRow matTooltip="Editar" icon="pi pi-pencil"
                            [disableNoPermission]="permissaoEditarLancamento" (click)="onRowEditLoteInit(lote)" text rounded severity="secondary"></button>
                            <a [routerLink]="pathEditLote" [queryParams]="getQueryLote(lote)" pButton pRipple
                            matTooltip="Abrir janela de edição" icon="pi pi-file-edit" text rounded severity="secondary" [disableNoPermission]="permissaoEditarLancamento"></a>
                          </div>
                        }
                        @if (editing) {
                          <div class="inline-element items-center">
                            <button pButton pRipple type="button" pSaveEditableRow matTooltip="Salvar" icon="pi pi-check"
                            (click)="onRowEditLoteSave(lote)" text rounded severity="secondary"></button>
                            <button pButton pRipple type="button" pCancelEditableRow matTooltip="Cancelar" icon="pi pi-times"
                            (click)="onRowEditLoteCancel(lote)" text rounded severity="secondary"></button>
                          </div>
                        }
                      </td>
                    </tr>
                  </ng-template>
                  <!-- Modelo da Tabela secundaria -->
                  <ng-template #expandedrow let-lote let-rowIndex="rowIndex" let-editing="editing">
                    <tr>
                      <td colspan="6">
                        <div class="table-container">
                          <!-- Conteudo da tabela secundaria -->
                          <p-table #tabelaLancamentos [value]="lote.lancamentos" dataKey="id" editMode="row">
                            <ng-template pTemplate="header">
                              <tr>
                                <th pSortableColumn="conta">Conta <p-sortIcon field="conta" /></th>
                                <th pSortableColumn="tipoLancamento">Tipo Lançamento <p-sortIcon field="tipoLancamento" /></th>
                                <th pSortableColumn="valor">Valor <p-sortIcon field="valor" /></th>
                                <th pSortableColumn="correspondencia">Conciliado <p-sortIcon field="correspondencia" /></th>
                                <th style="width: 130px;"></th> <!-- Espaço para botões -->
                              </tr>
                            </ng-template>
                            <ng-template #body let-lancamento let-rowIndex="rowIndex" let-editing="editing">
                              <tr [pEditableRow]="lancamento">
                                <td>{{ lancamento.conta }}</td>
                                <td>
                                  <p-cellEditor>
                                    <ng-template #input>
                                      <app-generic-autocomplete [items]="tiposLancamento" displayField="nome" label="Tipo de lançamento"
                                        inputId="tipoLancamento-{{ lancamento.id }}" [(ngModel)]="lancamento.tipoLancamento">
                                      </app-generic-autocomplete>
                                    </ng-template>
                                    <ng-template #output>
                                      {{ lancamento.tipoLancamento.nome }}
                                    </ng-template>
                                  </p-cellEditor>
                                </td>
                                <td>
                                  <p-cellEditor>
                                    <ng-template #input>
                                      <p-inputnumber type="text" mode="currency" currency="BRL" [(ngModel)]="lancamento.valor" />
                                    </ng-template>
                                    <ng-template #output>
                                      <div [ngClass]="[lancamento.valor < 0 ? 'red-text' : 'green-text']">
                                        {{ lancamento.valor | currency:'BRL' }}
                                      </div>
                                    </ng-template>
                                  </p-cellEditor>
                                </td>
                                <td><mat-checkbox [(ngModel)]="lancamento.conciliado" [disabled]="true"></mat-checkbox></td>
                                <td>
                                  @if (!editing) {
                                    <div class="inline-element items-center">
                                      <button pButton pRipple type="button" pInitEditableRow matTooltip="Editar" icon="pi pi-pencil"
                                        [disabled]="lancamento.conciliado" [disableNoPermission]="permissaoEditarLancamento"
                                      (click)="onRowEditLancamentoInit(lancamento)" text rounded severity="secondary"></button>
                                      <button pButton icon="pi pi-ellipsis-v" text rounded severity="secondary" [matMenuTriggerFor]="menuLancamento">
                                      </button>
                                    </div>
                                  }
                                  @if (editing) {
                                    <div class="inline-element items-center">
                                      <button pButton pRipple type="button" matTooltip="Salvar" pSaveEditableRow icon="pi pi-check"
                                      (click)="onRowEditLancamentoSave(lancamento)" text rounded severity="secondary"></button>
                                      <button pButton pRipple type="button" matTooltip="Cancelar" pCancelEditableRow icon="pi pi-times"
                                      (click)="onRowEditLancamentoCancel(lancamento)" text rounded severity="secondary"></button>
                                    </div>
                                  }
                                  <mat-menu #menuLancamento="matMenu" xPosition="before">
                                    <button mat-menu-item class="inline-element accent-color"
                                      [disableNoPermission]="permissaoEditarLancamento"
                                      (click)="onMoverLancamentoDeLoteClick(lancamento, lote)">
                                      <i class="button-menu-icon pi pi-arrow-right-arrow-left"></i>
                                      Mover para outro lote
                                    </button>
                                    <button mat-menu-item class="inline-element accent-color" [disabled]="lancamento.conciliado"
                                      [disableNoPermission]="permissaoEditarLancamento" (click)="onDeleteLancamentoClick(lancamento)">
                                      <i class="button-menu-icon pi pi-trash"></i>
                                      Excluir
                                    </button>
                                  </mat-menu>
                                </td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            }

            @if (diaExibido === undefined) {
              <div class="accent-color sem-selecao-lote">
                Selecione um dia ao lado para exibir os lançamentos
              </div>
            }

          </div>
        </ng-template>

        <!-- Tabela do resumo dos dias -->
        <ng-template #panel>
          @if (movimentacaoCaixaInfo !== undefined && movimentacaoCaixaInfo.diasCaixa.length > 0) {
            <div class="resumo-dias-container">
              <div class="resumo-diferenca"
             [ngClass]="{
               'ok': movimentacaoCaixaInfo.diferencaTotal === 0,
               'orange-warning-diferenca': movimentacaoCaixaInfo.diferencaTotal !== 0
             }">
                @if (movimentacaoCaixaInfo.diferencaTotal !== 0) {
                  <i class="pi pi-exclamation-triangle icon"></i>
                  Diferença total dias buscados:
                  <strong>{{ movimentacaoCaixaInfo.diferencaTotal | currency:'BRL' }}</strong>
                  • {{ movimentacaoCaixaInfo.diasComDiferenca }} {{ movimentacaoCaixaInfo.diasComDiferenca === 1 ? 'dia' : 'dias' }}
                  com diferença
                } @else {
                  <i class="pi pi-check icon"></i>
                  Nenhuma diferença nos dias buscados
                }
              </div>
              <div class="table-container resumo-dias-table">
                <p-table [value]="movimentacaoCaixaInfo.diasCaixa" [scrollable]="true" scrollHeight="flex" dataKey="id"
                  selectionMode="single" [(selection)]="diaSelecionado" (onRowSelect)="onDiaSelect($event)" [paginator]="true"
                  [rows]="100" [rowsPerPageOptions]="[25,50,100]">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Data</th>
                      <th>Diferença</th>
                      <th>Receita</th>
                      <th>Despesa</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-element let-rowIndex="rowIndex">
                    <tr [pSelectableRow]="element" [pSelectableRowIndex]="rowIndex">
                      <td>{{ element.data | date:'dd/MM/yyyy' }}</td>
                      <td [ngClass]="{'orange-warning-diferenca': element.diferenca !== 0}">{{ element.diferenca | currency:'BRL'
                      }}</td>
                      <td [ngClass]="{'green-text': element.receita !== 0}">{{ element.receita | currency:'BRL' }}</td>
                      <td [ngClass]="{'red-text': element.despesa !== 0}">{{ element.despesa | currency:'BRL' }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          }

          @if (movimentacaoCaixaInfo === undefined) {
            <div>
              Realize uma busca para visualizar os lançamentos
            </div>
          }
          @if (movimentacaoCaixaInfo !== undefined && movimentacaoCaixaInfo.diasCaixa.length === 0) {
            <div class="accent-color sem-lancamento-periodo">
              Nenhum lançamento para o periodo selecionado
            </div>
          }
        </ng-template>
      </p-splitter>

    </div>

  </smrts-page>